import { createCleanMarkup } from '../../../../../../utils/common';
import StepContentPanel from '../../../StepContentPanel';
import React from 'react';
import { CmsContent } from '../../../proctorStepsTypes';
import { Room } from '../../../../../../types/Rooms';

interface Props {
  cmsContent: CmsContent | undefined;
  room: Room;
  img?: React.ReactNode;
  imgDesc?: React.ReactNode | string;
  finalStepNumber: number;
}

export const SetupComplete: React.FC<Props> = ({ cmsContent, room, img, imgDesc, finalStepNumber }) => {
  const setupCompleteContent = cmsContent?.steps?.find((n) => n.step_number === finalStepNumber);
  const setupCompleteText = (
    <div dangerouslySetInnerHTML={createCleanMarkup(setupCompleteContent?.main_panel_content)} />
  );
  const detailPanelData = (
    <div dangerouslySetInnerHTML={createCleanMarkup(setupCompleteContent?.detail_panel_content)} />
  );
  const content = {
    main_panel_header: setupCompleteContent?.main_panel_header,
    main_panel_content: setupCompleteText,
    detail_panel_content: detailPanelData,
  };

  return (
    <StepContentPanel
      heading='Setup Complete'
      room={room}
      showStepCompletePanel
      content={content}
      invertStyle
      desc={setupCompleteText}
      img={img}
      imgDesc={imgDesc}
    />
  );
};
